import React, { useEffect, useState } from 'react';
import { CollapsableSection } from '../../atoms';

import './ArtArchive.scss';



type Month = '00' | '01' | '02' | '03' | '04' | '05' | '06' | '07' | '08' | '09' | '10' | '11' | '12';

type ArtList = {
  [year: string]: {
    [key in Month]: { filename: string, extension: string }[]
  }
};

const MONTH_LABELS: { [key in Month]: string } = {
  '00': 'Unsorted',
  '01': 'Jan',
  '02': 'Feb',
  '03': 'Mar',
  '04': 'Apr',
  '05': 'May',
  '06': 'Jun',
  '07': 'Jul',
  '08': 'Aug',
  '09': 'Sep',
  '10': 'Oct',
  '11': 'Nov',
  '12': 'Dec'
};

export const ArtArchive = () => {
  const [artList, setArtList] = useState<ArtList>({});
  const [loading, setLoading] = useState(true);
  const [fullscreenImage, setFullscreenImage] = useState('');
  const [showFullscreenImage, setShowFullscreenImage] = useState(false);
  const [currentFilename, setCurrentFilename] = useState('');

  const getArt = async () => {
    setLoading(true);
    const data = await (await fetch('/art/library.json')).json() as ArtList;
    setArtList(data);
    setLoading(false);
  };

  useEffect(() => {
    getArt();
  }, []);

  if (loading) {
    return (
      <div>loading please wait...</div>
    );
  }

  return (
    <div className='artArchive'>
      {showFullscreenImage ? (
        <div className='artArchive__fullImageDisplay'>
          <button onClick={() => setShowFullscreenImage(false)}>[Close]</button>
          <img src={fullscreenImage}/>
          <h2>{currentFilename}</h2>
        </div>
      ) : null}
      {Object.entries(artList).sort().reverse().map(([year, data]) => {
        return (
          <CollapsableSection
            title={(<h2 className='artArchive__year__title'>{year}</h2>)} 
            key={year}
            showScrollToTopButton
          >
            <ol className='artArchive__months'>
              {Object.entries(data).sort().reverse().map(([month, images]) => (
                <li className='artArchive__month' key={month}>
                  <CollapsableSection
                    title={(<h3 className='artArchive__month__title'>{MONTH_LABELS[month as Month]}</h3>)} 
                    key={month}
                    expanded
                  >
                    <ul className='artArchive__images'>
                      {images.map(({ filename, extension }) => {
                        const imgSrc = `/art/${year}/${month}/${filename}`;
                        return (
                          <li key={filename} className='artArchive__image'>
                            <button onClick={() => {
                              setFullscreenImage(`${imgSrc}.${extension}`);
                              setShowFullscreenImage(true);
                              setCurrentFilename(filename);
                            }}>
                              <img src={`${imgSrc}-thumb.${extension}`}/>
                              {filename}
                            </button>
                          </li>
                        );
                      })}
                    </ul>
                  </CollapsableSection>
                </li>
              ))}
            </ol>
          </CollapsableSection>
        );
      })}
    </div>
  );
};